/*
 Login component
 url match: / or /login
 Displays email id and password field
 with Login button
*/
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../../Styles/loginStyles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'
import BackgroundImage from '../../Common/BackgroundImage';

@inject('userStore')
@observer
class ForgotPassword extends React.Component {

    state = {
        user: {
            email: ""
        },
        validationErrors: {},
        showStatusText: false
    }

    componentWillUnmount() {
        // this.props.userStore.reset();
    }

    componentDidMount() {
        if (this.props.userStore.token)
            this.props.history.push("/dashboard/drafts")
    }

    handleChange = (field, value) => {
        const user = Object.assign({}, this.state.user, {
            [field]: value
        });
        this.setState({ user });
    }

    onClickBack = () =>{
        this.props.history.push("/login")
    }

    login = (e) => {
        e.preventDefault();
        const { user } = this.state;
        /*if(!isObjectEmpty(validationErrors)) {
            this.setState({errorMessage: "Please correct the above errors before proceeding."});
            return;
        }*/
        if (!user.email || !this.props.userStore.validateEmail(user.email)) {
            this.setState({ errorMessage: "Please enter a valid email ID before proceeding." });
            return;
        }
        else {
            this.setState({ errorMessage: undefined });
            this.props.userStore.requestPasswordReset(user.email)
                .then((res) => {
                    this.setState({
                        showStatusText: true
                    })
                });
        }
    }

    render() {
        const { inProgress, statusText } = this.props.userStore;
        const { classes } = this.props;
        const { user, showStatusText } = this.state;
        const validationErrors = this.state.validationErrors;

        return (
            <div className={classes.rowFlex} style={{overflowY: 'hidden'}}>
                <div style={{ width: '50%' }}>
                    <BackgroundImage/>
                </div>
                <div className="loginContainer">
                    <Link to="/">
                        <ReactSVG
                            beforeInjection={svg => {
                                svg.classList.add(classes.svg)
                            }}
                            src={Images.bigLogo} />
                    </Link>
                    <p className={classes.pageHeading}>Reset your password?</p>
                    <p className={classes.descText}>Please provide your email address that you used when you signed up for your account.</p>
                    <p className={classes.descText}>We will send you an email to reset your password</p>
                    <form noValidate autoComplete="off" className={classes.formStyle}>
                        <FormControl margin="normal" variant="filled" error aria-describedby="component-error-text" className={classes.formContainer}>
                            <TextField
                                required
                                id="email-input"
                                placeholder="Email"
                                type="email"
                                name="email"
                                autoComplete="email"
                                margin="normal"
                                variant="filled"
                                InputProps={{
                                    disableUnderline: true,
                                    classes: {
                                        input: classes.formField                                    },
                                }}
                                value={user.email}
                                onChange={(event) => this.handleChange("email", event.target.value)}
                            />
                            {validationErrors.email && <FormHelperText id="email-error">{validationErrors.email}</FormHelperText>}
                        </FormControl>
                        {this.state.errorMessage && <p className={classes.errorStyle}>{this.state.errorMessage}</p>}
                        {showStatusText && statusText && <p className={classes.errorStyle}>{statusText}</p>}
                        {
                            inProgress ? <Button variant="contained" className={classes.button} fullWidth>
                                <Loader height={30} width={30} color={this.props.theme.palette.white} />
                            </Button> :
                                <Button variant="contained" className={classes.button} type="submit" onClick={this.login} fullWidth>
                                    Send Reset Link
                      </Button>
                        }
                        <p className={classes.backHomeText} onClick={(e)=>this.onClickBack()}>Back to Home</p>
                    </form>

                </div>
            </div>
        );
    }
}
export default withStyles(loginStyles, { withTheme: true })(withRouter(ForgotPassword));
